export default __webpack_public_path__ + "static/media/storm.8571028f.png";